<div class="d-flex justify-content-between align-items-center">
    <h2 mat-dialog-title>Send Message</h2>
    <h5 mat-dialog-title>Contacts : {{contact_count}}</h5>
</div>

<form (ngSubmit)="Send_Message()">
    <div mat-dialog-content class="content">

        <mat-form-field appearance="outline" style="width: 350px;">
            <mat-label>Send Message</mat-label>
            <textarea [(ngModel)]="message" [ngModelOptions]="{standalone: true}" style="height: 320px;" matInput
                placeholder="Write Message Here..."></textarea>
        </mat-form-field>

        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">Send</button>
        </div>
    </div>
</form>